import {
  BankOutlined,
  CalendarOutlined,
  EditOutlined,
  FileDoneOutlined,
  HomeOutlined,
  LaptopOutlined,
  PieChartOutlined,
  SettingOutlined,
  SnippetsOutlined,
  DatabaseOutlined,
  FileAddOutlined,
  TeamOutlined,
  NotificationOutlined,
  SafetyCertificateOutlined,
  ApartmentOutlined,
  ScheduleOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import { HOME_PATH } from "../../pages/home";
import { TASKS_LIST_PATH } from "../../../tasks/pages/tasks";
import { TASKS_ADMIN_PATH } from "@/modules/tasks/pages/tasks-admin";
import { PROJECTS_PATH } from "@/modules/tasks/pages/projects";
import { MY_WORK_PATH } from "@/modules/tasks/pages/my-work";
import { TASKS_CONTROL_PATH } from "@/modules/tasks/pages/tasks-control";
import { REQUESTS_PATH } from "@/modules/requests/pages/requests";
import { SURVEY_LIST_PATH } from "@/modules/survey/pages/survey-list";
import { MY_SURVEYS_PATH } from "@/modules/survey/pages/my-surveys";
import { COMPANY_STRUCTURE_PATH } from "../../pages/company-structure/main";
import { FINANCE, SURVEY } from "@/shared/modules/constants/modules-id";
import { ASSETS_LIST_PATH } from "@/modules/assets/pages/assets-list";
import { EnabledTokens } from "gql/graphql";
import { generatePath } from "react-router-dom";
import { EMPLOYEES } from "../../pages/company-structure/main/model/use-tab-param";
import { MY_TEAM_PATH } from "@/modules/my-team";
import { MY_ASSETS_PATH } from "@/modules/assets/pages/my-assets";
import { REQUEST_REGISTRY_PATH } from "@/modules/requests/pages/request-registry";
import { NavigationItem } from "./model/types";
import { documentRegisterMenuItems } from "@/modules/document-register/";
import { signingMenuItems } from "@/modules/signing";
import { crmMenu } from "@/modules/crm/menu";
import { SETTINGS_MENU_PATH } from "@/modules/settings/pages/settings-menu";
import { settingsMenuPermissions } from "@/modules/settings/pages/settings-menu/data/permissions-for-menu-item";
import { timesheetMenu } from "@/modules/timesheet";
import { recruitingMenu } from "@/modules/recruiting";
import { reportMenu } from "@/modules/reports";
import { documentsMenu } from "@/modules/documents";
import { MY_POSTS_PATH, POSTS_MODERATION_PATH } from "@/modules/feed";

export const menuItems: NavigationItem[] = [
  {
    label: "home page",
    icon: <HomeOutlined />,
    to: HOME_PATH,
  },
  {
    key: "feed-group",
    label: "feed",
    icon: <NotificationOutlined />,
    children: [
      {
        label: "my posts",
        icon: <EditOutlined />,
        to: MY_POSTS_PATH,
      },
      {
        label: "posts moderation",
        icon: <SafetyCertificateOutlined />,
        to: POSTS_MODERATION_PATH,
        requiredAtLeastOnePermission: [EnabledTokens.FeedModerate],
      },
    ],
  },
  {
    key: "tasks-group",
    label: "tasks",
    icon: <FileDoneOutlined />,
    children: [
      {
        label: "tasks",
        icon: <FileDoneOutlined />,
        to: TASKS_LIST_PATH,
      },
      {
        label: "projects",
        icon: <ApartmentOutlined />,
        to: PROJECTS_PATH,
      },
      {
        label: "my tasks",
        icon: <ScheduleOutlined />,
        to: MY_WORK_PATH,
      },
      {
        label: "tasks control",
        icon: <DashboardOutlined />,
        to: TASKS_CONTROL_PATH,
      },
      {
        label: "administration",
        icon: <SettingOutlined />,
        to: TASKS_ADMIN_PATH,
        // Право «чужие задачи» контекстное, а пункт показывается до всякой записи:
        // уровень спросить не у кого. Пункт даёт сам факт доступа хоть к чьим-то
        // задачам — та же проверка стоит на входе в саму страницу.
        requiredAtLeastOnePermission: [EnabledTokens.TasksTasks],
      },
    ],
  },
  {
    label: "requests",
    icon: <FileDoneOutlined />,
    children: [
      {
        label: "my requests",
        icon: <FileAddOutlined />,
        to: REQUESTS_PATH,
      },
      {
        label: "request registry",
        icon: <DatabaseOutlined />,
        to: REQUEST_REGISTRY_PATH,
        requiredAtLeastOnePermission: [EnabledTokens.TasksApprovingRegister],
      },
    ],
  },
  {
    label: "company",
    icon: <BankOutlined />,
    to: generatePath(COMPANY_STRUCTURE_PATH, {
      tab: EMPLOYEES,
    }),
  },
  {
    label: "my team",
    icon: <TeamOutlined />,
    to: MY_TEAM_PATH,
    requiredIsManager: true,
  },
  {
    label: "calendar",
    icon: <CalendarOutlined />,
    to: "/calendar",
  },
  recruitingMenu,
  {
    label: "assets",
    icon: <LaptopOutlined />,
    children: [
      {
        label: "My assets",
        icon: <DatabaseOutlined />,
        to: MY_ASSETS_PATH,
        requiredModule: FINANCE,
      },
      {
        label: "Assets registry",
        icon: <DatabaseOutlined />,
        to: ASSETS_LIST_PATH,
        requiredModule: FINANCE,
        requiredAtLeastOnePermission: [
          EnabledTokens.FinanceAssets,
          EnabledTokens.FinanceIssuedAssets,
        ],
      },
    ],
  },
  timesheetMenu,
  signingMenuItems,
  ...documentsMenu,
  ...documentRegisterMenuItems,
  {
    label: "surveys",
    icon: <PieChartOutlined />,
    requiredModule: SURVEY,
    children: [
      {
        label: "editor",
        icon: <EditOutlined />,
        to: SURVEY_LIST_PATH,
        requiredAtLeastOnePermission: [EnabledTokens.SurveysEditing],
      },
      {
        label: "my surveys",
        icon: <SnippetsOutlined />,
        to: MY_SURVEYS_PATH,
      },
    ],
  },
  ...reportMenu,
  ...crmMenu,
  {
    label: "settings",
    icon: <SettingOutlined />,
    to: SETTINGS_MENU_PATH,
    requiredAtLeastOnePermission: settingsMenuPermissions,
  },
];
